import classNames from "classnames";
import type { PropsWithChildren } from "react";
import { Icon } from "./Icon";
import { bgStyles, borderStyles, flexStyles, heightStyles, iconStyles, squareStyles, textStyles } from "./styles";
import type { PropsWithClassName, PropsWithIconType, PropsWithLabel, PropsWithOptionalClick } from "./types";
import { TextAccent } from "./typography";

interface Props
  extends PropsWithChildren,
    PropsWithClassName,
    PropsWithIconType,
    PropsWithLabel,
    PropsWithOptionalClick {
  round?: boolean;
  forcePrompt?: boolean;
}

export function ContentContainer({
  iconType,
  label,
  round = false,
  className,
  children,
  onClick,
  forcePrompt = false,
}: Props) {
  const renderPrompt = !children || forcePrompt;
  return (
    <div
      onClick={onClick}
      className={classNames(
        flexStyles.alignSelfCenter,
        flexStyles.vert,
        flexStyles.justifyCenter,
        iconStyles.businessDarkOrSecondary300,
        heightStyles.min500,
        bgStyles.editorBackground,
        borderStyles.editorBorderDashed,
        {
          [borderStyles.radius025]: !round,
          [borderStyles.radiusRound]: round,
          [squareStyles.square1000]: round,
        },
        className,
      )}
    >
      {renderPrompt && (
        <div
          className={classNames(
            flexStyles.vert050,
            flexStyles.alignCenter,
            flexStyles.justifyCenter,
            heightStyles.full,
            textStyles.secondary300,
            textStyles.editorInterface,
            iconStyles.editorInterface,
            textStyles.center,
          )}
        >
          <Icon iconType={iconType} />
          <TextAccent>{label}</TextAccent>
        </div>
      )}
      {children}
    </div>
  );
}
